define('pwa/plugin/tickets/controller/TicketsController',['require','lib/controller/BaseController','pwa/plugin/tickets/view/TicketsLayoutView'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var TicketsLayoutView = require('pwa/plugin/tickets/view/TicketsLayoutView');

    /**
     * @class TicketController
     */
    return BaseController.extend({

        clientTickets: function (type) {
            this.getMainLayout().getContentRegion().show(
                new TicketsLayoutView({
                    data: {
                        type: type,
                    },
                    clientModel: this.getOption('clientModel'),
                })
            );
        },

    });

});
